import { ICoreUser } from '../../../../shared-interfaces/User/ICoreUser';
import { IRetentionStatus } from '../../../../shared-interfaces/User/IRetentionStatus';
import { IUserRetentionStatus } from '../../../../shared-interfaces/User/IUserRetentionStatus';
import { IUserManagementFilter } from './IUserManagementFilter';

export interface IUserManagementState {
  selectAll: boolean;
  excludeUsers: ICoreUser[];

  filter: IUserManagementFilter;
  users: ICoreUser[];
  // retentionStatuses: IRetentionStatus[];
  userRetentionStatuses: { [userId: string]: IUserRetentionStatus };
  selectedUsers: ICoreUser[];
}

export const userManagementInitialState = (): IUserManagementState => {
  return {
    selectAll: false,
    excludeUsers: [],

    filter: {
      search: '',
      roles: [],
      retentionStatus: [] as number[],
    },
    users: [],
    // retentionStatuses: [] as IRetentionStatus[],
    userRetentionStatuses: {},
    selectedUsers: [],
  } as IUserManagementState;
};
